"use client";

import { BreachesSection } from "./breaches-section";
import { BreachesLiveDemo } from "./breaches-live-demo";

export function BreachesHero() {
  return (
    <BreachesSection>
      <div className="flex flex-col items-center pt-24 pb-40 text-center sm:pt-28">
        {/* LCP text: painted immediately, transform-only slide (no opacity fade). */}
        <div className="hero-rise-lcp flex flex-col items-center">
          <h1 className="text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl md:text-6xl">
            Is your password
            <br />
            <span className="text-brand">already breached?</span>
          </h1>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-balance text-text-tertiary">
            Privately check if a password has leaked in known breaches - via k-anonymity, so
            it never leaves your side.
          </p>
        </div>

        <div className="hero-rise hero-rise-1 mt-14 w-full">
          <BreachesLiveDemo />
        </div>
      </div>
    </BreachesSection>
  );
}
